@if (disabilityProofs().length > 0) {
	<section class="lvr-shared-list">
		<div class="lvr-shared-list__header">
			<h3>{{ 'client.disability.proofs' | transloco }}</h3>
		</div>
		<div class="lvr-shared-list__body">
			@for (proof of disabilityProofs(); track proof.id) {
				<a class="lvr-shared-list__record link" [routerLink]="['proofs', proof.id]">
					<lvr-disability-proof-item [proof]="proof"></lvr-disability-proof-item>
				</a>
			}
		</div>
		<lvr-paginator
			[length]="totalItems()"
			[pageSize]="pageSize()"
			[pageIndex]="pageIndex()"
			[showFirstLastButtons]="showFirstLastButtons()"
			[hidePageSize]="hidePageSize()"
			preferenceKey="disability-proof-list"
			(page)="handlePageEvent($event)"
		>
		</lvr-paginator>
	</section>
} @else {
	<h3 style="padding-top: 32px">{{ 'client.disability.proofs' | transloco }}</h3>
	<p>{{ 'client.disability.no_proofs' | transloco }}</p>
}
